export default  () => {
    localStorage.clear();
    window.location.href = '/notAuthenticated';
}
